import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2022-02-26 15:07:02
 * @LastEditTime: 2022-02-26 16:17:20
 * @LastEditors: wangshengqiang
 * @Description: 
 */
import React from 'react'; // eslint-disable-next-line import/no-duplicates

import { SignArea, FormItem } from '@/baseComponents';
import './index.less';
export default function InsurerSign(props) {
  const {
    formKey = 'insuredList[0].signImageUrl',
    // label,
    rules = [{
      required: true,
      message: '请输入'
    }],
    remark = {}
  } = props;
  const formItemProps = {
    label: null,
    remark,
    name: formKey,
    fieldOption: {
      rules
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "SignContent"
  }, /*#__PURE__*/React.createElement("div", null, "\u5728\u7EBF\u7B7E\u540D"), /*#__PURE__*/React.createElement(FormItem, _extends({}, props, formItemProps, {
    noStyle: true
  }), /*#__PURE__*/React.createElement(SignArea, null))));
}